import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

/** Gates authenticated routes; redirects to /login when unauthenticated. */
export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  if (status === 'loading') {
    return <div className="p-10 text-sm text-muted">Loading…</div>;
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
